'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    WrapComponent: 'div',
    transitionName: 'am-slide-up',
    maskTransitionName: 'am-fade'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/picker/popupProps.js
// module id = 292
// module chunks = 0